var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 19C38 29.4934 29.4934 38 19 38C8.50659 38 0 29.4934 0 19C0 8.50659 8.50659 0 19 0C29.4934 0 38 8.50659 38 19ZM12 19.5C12 18.6716 12.6716 18 13.5 18H17C17.5523 18 18 17.5523 18 17V13.5C18 12.6716 18.6716 12 19.5 12C20.3284 12 21 12.6716 21 13.5V17C21 17.5523 21.4477 18 22 18H25.5C26.3284 18 27 18.6716 27 19.5C27 20.3284 26.3284 21 25.5 21H22C21.4477 21 21 21.4477 21 22V25.5C21 26.3284 20.3284 27 19.5 27C18.6716 27 18 26.3284 18 25.5V22C18 21.4477 17.5523 21 17 21H13.5C12.6716 21 12 20.3284 12 19.5Z",
    fill: "#CA1211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2d684b7cdd10a9d0ba596200631d3787.svg";
export { ForwardRef as ReactComponent };